import React from 'react';
import { useChanges, Form } from '../../../../../../components/Form/Form';
import { EventBase, updateEventDetails } from '../../../../../../model/event';
import { ModalController } from '../../../../../../components/Modal/ControlledModal';
import { Datepicker } from '../../../../../../components/Form/Datepicker/Datepicker';
import { t } from '../../../../../../locales/translate';
import { handleError } from '../../../../../../model/notification';
import { Stack } from '../../../../../../components/Stack/Stack';

interface Props {
  controller: ModalController<EventBase>;
}

export function ShippableFromForm({ controller }: Props): JSX.Element {
  const [changes, , event, trackChanges] = useChanges<EventBase>(controller.model);

  async function handleOnSubmit(): Promise<void> {
    try {
      await updateEventDetails({ eventId: event.id, changes });
      controller.close();
    } catch (error) {
      handleError(error);
    }
  }

  return (
    <Form model={event} onInput={trackChanges}>
      {(form) => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: form.valid,
        });
        return (
          <Stack>
            <Datepicker label={t.model.product.shippableFrom} name="shippableFrom" displayOptional={false} />
            <Datepicker
              label={t.model.product.publicShippableFrom}
              name="publicShippableFrom"
              disabledDays={[{ before: new Date() }]}
            />
            <Datepicker name="dhlShippingFrom" hourpicker label={t.model.product.dhlShippableFrom} />
          </Stack>
        );
      }}
    </Form>
  );
}
